import { Component, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild, inject } from '@angular/core';
import {DateAdapter} from '@angular/material/core';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { MatInput } from '@angular/material/input';
import { MatDatepickerInput, MatDatepickerToggle, MatDatepicker } from '@angular/material/datepicker';
import { FormsModule } from '@angular/forms';
import { MatSuffix } from '@angular/material/form-field';
import { DatePipe } from '@angular/common';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-date-month',
    templateUrl: './date-month.component.html',
    styleUrls: ['./date-month.component.scss'],
    imports: [MatInput, MatDatepickerInput, FormsModule, MatDatepickerToggle, MatSuffix, MatDatepicker, MatButton, DatePipe, TranslateModule]
})
export class DateMonthComponent implements OnInit, OnChanges {
    private _adapter = inject<DateAdapter<any>>(DateAdapter);
    translate = inject(TranslateService);

    private _value;
    @Input()
    public set value(value) {
        this._value = value;
    }

    public get value() {
        return this._value;
    }

    @Input() public valid = true;

    private _dateMax;
    @Input()
    public set dateMax(value) {
        if (!value) {
            this._dateMax = null;
        } else {
            this._dateMax = this.convertDate(value);
        }
    }

    public get dateMax() {
        return this._dateMax;
    }

    private _dateMin;
    @Input()
    public set dateMin(value) {
        if (!value) {
            this._dateMin = null;
        } else {
            this._dateMin = this.convertDate(value);
        }
    }

    public get dateMin() {
        return this._dateMin;
    }

    @Input() disabled = false;

    @ViewChild('picker', { static: true }) picker;

    @Output() dateChange: EventEmitter<Date> = new EventEmitter<
        Date
    >();

    constructor()
    {
        this._adapter.setLocale(this.translate.currentLang);
    }

    ngOnInit() {
    }

    monthSelected(event) {
        this.value = event;
        this.picker.close();
        const tmp = new Date(event);
        this.dateChange.emit(tmp);
    }

    openPicker() {
        if (!this.disabled) {
            this.picker.open();
        }
    }

    convertDate(date: string | Date) {
        if (typeof date == 'object') {
            return date;
        } else if (typeof date == 'string') {
            return new Date(date);
        }
    }

    public displayDate() {
        if (this.value) {
            this.value;
        } else {
            return 'Choisissez une date';
        }
    }

    ngOnChanges() {
        this.valid = this.valid;
    }
}
